import { Form } from "formik"
import { FC, ReactNode } from "react"

import { baseAuthFormContainer } from "./AuthForm.css"

export const AuthForm: FC<{ children: ReactNode }> = ({ children }) => (
  <Form className={baseAuthFormContainer}>{children}</Form>
)
